// Anything an operator acts on directly. A click that lands inside one of
// these belongs to the control, not to the surface around it: a card that
// expands, a table row that opens. One list, so the two never disagree about
// what counts as a control.
export const INTERACTIVE_ELEMENT_SELECTOR = 'a, button, input, select, textarea, summary, [role="button"], [role="link"], [role="menuitem"], [tabindex]:not([tabindex="-1"])'

// The nearest control at or above `target` that is inside `container`,
// including the container itself when it is focusable, or null. A match
// outside the container is not the container's control: a menu opened from
// it renders in a portal, and the container may sit inside a focusable panel.
export function interactiveAncestorWithin(target, container) {
  const control = target?.closest?.(INTERACTIVE_ELEMENT_SELECTOR)
  return control && container.contains(control) ? control : null
}

// What makes a table row one control that opens something: focusable, named,
// opened by a click (unless the click landed on a control inside the row)
// and by Enter or Space while the row itself has focus.
export function clickableRowProps(onActivate, label) {
  return {
    tabIndex: 0,
    'aria-label': label,
    onClick: (event) => {
      const control = interactiveAncestorWithin(event.target, event.currentTarget)
      if (control && control !== event.currentTarget) return
      onActivate()
    },
    onKeyDown: (event) => {
      if (event.target !== event.currentTarget) return
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onActivate()
      }
    },
  }
}
